
import { PuttSituation } from "@/types/golf";

export const longPutts: PuttSituation = {
  id: 1,
  name: "Putts longs",
  image: "/lovable-uploads/621a311d-6794-4a0d-9a59-51ebcc89fffe.png?width=800",
  description: "Sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez la position de départ de 3 situations de jeu : A=13m, B=19m, C=25m.  Placez 3 balles à chaque point (A, B et C). Jouez ensuite une balle de chaque point successivement, en faisant les 3 tentatives requises.",
  distances: [
    { point: "A", distance: 13, ballCount: 3 },
    { point: "B", distance: 19, ballCount: 3 },
    { point: "C", distance: 25, ballCount: 3 },
  ],
  scoring: [
    { condition: "Balle rentrée", points: 4 },
    { condition: "Balle à moins de 1m", points: 2 },
    { condition: "Balle entre 1m et 2m", points: 1 },
    { condition: "Balle au-delà de 2m", points: 0 },
  ],
  indexTable: [
    { points: 0, index: 39 },
    { points: 1, index: 33 },
    { points: 2, index: 27 },
    { points: 3, index: 21 },
    { points: 4, index: 16 },
    { points: 5, index: 12 },
    { points: 6, index: 9 },
    { points: 7, index: 6 },
    { points: 8, index: 4 },
    { points: 9, index: 2 },
    { points: 10, index: 0 },
    { points: 11, index: -2 },
    { points: 12, index: -3 },
    { points: 13, index: -4 },
    { points: 14, index: -5 },
    { points: 15, index: -6 },
    { points: 16, index: -7 },
    { points: 17, index: -8 },
  ],
};
